import React from'react';
import { useLocale } from '../../localization/LocaleContext';

function Ticks(){
    const { t } = useLocale();
    return(
        <div className="ticks flex">
            <img src="/images/Group65.png" className="mr-10 first-tick ticks-size" alt={t('ticks.moneyBackAlt')} />
                <p className="ticks-p mb-0">{t('ticks.moneyBack')}</p>                   
            <img src="/images/Group65.png" className="mr-10 second-tick ticks-size" alt={t('ticks.cancelAnytimeAlt')} />
                <p className="ticks-p mb-0">{t('ticks.cancelAnytime')}</p>
        </div>
    )
}

export default Ticks;